/**
 * Date-extensions locale Ukrainian [uk]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('uk', {
    monthNames: ['січень','лютий','березень','квітень','травень','червень','липень','серпень','вересень','жовтень','листопад','грудень'],
    monthShortNames: ['січ','лют','бер','квіт','трав','черв','лип','серп','вер','жовт','лист','груд'],
    dayNames: ['неділя','понеділок','вівторок','середа','четвер','п’ятниця','субота'],
    dayShortNames: ['нд','пн','вт','ср','чт','пт','сб']
});
